export const NETWORK_CODE_MODES = {
	CUSTOM_NETWORK_CODE: 'CUSTOM_NETWORK_CODE',
	SPLIT_DOC_NETWORK_CODE: 'SPLIT_DOC_NETWORK_CODE'
};

export const SUCCESS_COPY_MESSAGES = {
	CUSTOM_NETWORK_CODE: 'Custom Network Code Copied',
	SPLIT_DOC_NETWORK_CODE: 'Split Doc Network Code Copied'
};
